export default __webpack_public_path__ + "static/media/14.d70b80b5.png";